import { useTaskFlow } from "../ai-task-button";
import { DraftDocumentResponse } from "../../../../data/types/ai-task-types";

interface DraftDocumentFlowProps {
    data: DraftDocumentResponse;
}

export function DraftDocumentFlow({ data }: DraftDocumentFlowProps) {
    const { setTaskComplete } = useTaskFlow();

    window.open(data.data.url, "_blank");
    setTaskComplete();

    return null;
}
